/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * A IOTest option.
 */
export const IOTestOption = /* #__PURE__ */ parsers.exactly('case', 'trailing_whitespace', 'substring', 'regex', 'all_whitespace');
